export class CardHeaderBody {
    title?: string;
    value?: string;

    constructor(title?: string, value?: string) {
        this.title = title;
        this.value = value;
    }
}